import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    ERROR: 'RequestSubmit/REQUEST_SUBMIT_ERROR',
    PENDING: 'RequestSubmit/REQUEST_SUBMIT_PENDING',
    SUCCESS: 'RequestSubmit/REQUEST_SUBMIT_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
